var Hour = /** @class */ (function () {
    function Hour() {
    }
    return Hour;
}());
export { Hour };
var ProductOption = /** @class */ (function () {
    function ProductOption() {
        this.filter = {};
        this.vip = false;
    }
    Object.defineProperty(ProductOption.prototype, "durationsAvailables", {
        get: function () {
            var _this = this;
            if (this.groupingAttributes != null && this.groupingAttributes["DURATION"]) {
                return this.groupingAttributes["DURATION"].map(function (dur) {
                    var time = dur.split("_")[0];
                    var unit = dur.split("_")[1].toUpperCase();
                    var caltime = _this.calculeTime(time, unit);
                    return { duration: caltime, durationName: unit, originalDuration: parseInt(time) };
                });
            }
            else {
                var time = this.duration; // Duration always arrives in 'minutes' 
                var type = this.durationName.toUpperCase();
                this.durationName = type;
                time = this.calculeTime(time, type);
                return [{ duration: time, durationName: this.durationName, originalDuration: this.duration }];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOption.prototype, "vehiclesAvailable", {
        get: function () {
            if (this.groupingAttributes != null && this.groupingAttributes["VEHICLE"]) {
                return this.groupingAttributes["VEHICLE"].map(function (vehicle) {
                    return { vehicleName: vehicle };
                });
            }
            else {
                return [{ vehicleName: this.vehicleName }];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductOption.prototype, "vipAvailable", {
        get: function () {
            if (this.groupingAttributes != null && this.groupingAttributes["VIP"].length > 1) {
                return this.groupingAttributes["VIP"] != null;
            }
            else {
                return this.vip;
            }
        },
        enumerable: true,
        configurable: true
    });
    ProductOption.prototype.calculeTime = function (duration, type) {
        if (type == 'HOUR') {
            duration /= 60;
        }
        else if (type == "DAY") {
            duration /= 60 * 24;
        }
        return duration;
    };
    return ProductOption;
}());
export { ProductOption };
